<div class="loader-wrapper flex justify-between">
  <div class="w-1/3">
    <app-shimmer-loader
      [theme]="{
        'height': '5rem'
      }"
      appearance="line"
    />
  </div>
  <div class="w-1/3">
    <app-shimmer-loader
        [theme]="{
        'height': '5rem'
      }"
      appearance="line"
    />
  </div>
</div>
